module.exports = __webpack_public_path__ + "a86062c9de1c0ff601343d5739ef93db.svg";